export const initialFormValues = {
  launch: 'Ajuste Geral de Prévia',
  date: '',
  totalValue: '',
  observations: ''
}
